import { render, staticRenderFns } from "./AdminPageCategories.vue?vue&type=template&id=7b3a0c84"
import script from "./AdminPageCategories.vue?vue&type=script&lang=js"
export * from "./AdminPageCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports